import BaseRest from "Utils/BaseRest";

var rest = new BaseRest({});

export default rest;